import { createContext, useContext } from 'react';

export interface CloakRouteConfig {
  basePath: string;
  dashboard: string;
  sites: string;
  sitesCreate: string;
  visitLogs: string;
  visitStats: string;
  domains: string;
  ruleTemplates: string;
  visitLimitTemplates: string;
  globalIpAcls: string;
}

export const CloakRouteContext = createContext<CloakRouteConfig | null>(null);

export interface CloakRouteProviderProps {
  config: CloakRouteConfig;
  children: React.ReactNode;
}

export const CloakRouteProvider: React.FC<CloakRouteProviderProps> = ({
  config,
  children,
}) => (
  <CloakRouteContext.Provider value={config}>
    {children}
  </CloakRouteContext.Provider>
);

export const useCloakRoutes = (): CloakRouteConfig => {
  const ctx = useContext(CloakRouteContext);
  if (!ctx) {
    throw new Error(
      'useCloakRoutes must be used within a CloakRouteProvider. ' +
        'Wrap your cloak module with <CloakRouteProvider config={...}>.',
    );
  }
  return ctx;
};
